/**
 *  @class
 *  @function CartDiscounts
 */
if (!customElements.get('cart-discounts')) {
  // The outcome of the last code applied, for the forms that redraws bring
  // in the next few seconds: one whose own redraw was skipped, or was
  // redrawn over, as theme.cart.draws orders them (app.js).
  // { open: the Discounts row was open, refused: the code doesn't apply, until }
  let outcome = null;

  class CartDiscounts extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.discounts();
      if (outcome && Date.now() < outcome.until) {
        if (outcome.open) this.closest('details')?.setAttribute('open', '');
        if (outcome.refused) this.querySelector('.cart-discounts--error')?.removeAttribute('hidden');
      }
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      }, {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    discounts() {
      const button = this.querySelector('.cart-discounts--button');
      const remove_discount_buttons = this.querySelectorAll('.cart-discounts--remove');

      if (!button) {
        return;
      }
      button.addEventListener('click', (event) => {
        event.preventDefault();
        button.classList.add('loading');
        this.updateDiscount();
      });
      remove_discount_buttons.forEach((remove_discount_button) => {
        remove_discount_button.addEventListener('click', this.removeDiscount.bind(this));
      });
    }
    updateDiscount() {
      const discountCode = this.querySelector('.cart-discounts--input');
      const discountCodeValue = discountCode.value;
      const existingDiscounts = this.existingDiscounts();

      // Already applied: nothing to send, so nothing to wait for.
      if (existingDiscounts.includes(discountCodeValue)) {
        this.querySelector('.cart-discounts--button')?.classList.remove('loading');
        return;
      }
      existingDiscounts.push(discountCodeValue);

      this.renderDiscounts(existingDiscounts, discountCodeValue);
    }
    removeDiscount(event) {
      const pill = event.target.previousElementSibling;
      const discountCode = pill.innerHTML;
      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;

      existingDiscounts.splice(index, 1);

      this.renderDiscounts(existingDiscounts);
    }
    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('.cart-discounts--name');
      for (const pill of discountPills) {
        discountCodes.push(pill.innerHTML);
      }

      return discountCodes;
    }
    renderDiscounts(existingDiscounts, discountCodeValue) {
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      var errorEl = this.querySelector('.cart-discounts--error');
      if (errorEl) errorEl.setAttribute('hidden', '');
      outcome = null;
      // Its place among the cart's redraws (theme.cart.draws).
      const sequence = theme.cart.claim();
      themeFetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body
      })
        .then((response) => response.json())
        .then((parsedState) => {
          // shopify:cart:discount-update — /cart/update.js responds with the full cart
          if (parsedState.token) {
            publishStandardEvent('CartDiscountUpdateEvent', {
              discountCodes: existingDiscounts.filter(Boolean).map((code) => ({ code: code })),
              promise: Promise.resolve({ cart: standardEventCart(parsedState) })
            }, this);
          }

          const wasDiscountOpen = !!this.closest('details[open]');
          const refused = !!discountCodeValue && (parsedState.discount_codes || []).some((discount) => {
            return discount.code === discountCodeValue && discount.applicable === false;
          });
          document.querySelectorAll('.cart-discounts--button').forEach((el) => {
            el.classList.remove('loading');
          });
          // A newer redraw already drawn keeps the cart, which is fetched
          // again: the form that redraw brings shows the outcome.
          const kept = { open: wasDiscountOpen, refused: refused, until: Date.now() + 5000 };
          if (!theme.cart.draws(sequence)) {
            outcome = kept;
            return;
          }
          // The redraw replaces this form along with the cart around it:
          // keep keyboard focus (CartFocus, app.js) in the drawer or cart.
          const root = this.closest('#Cart-Drawer, #Cart');
          const lines = '[id^="CartDrawerItem-"], [id^="CartItem-"]';
          const focus = root && CartFocus.capture(root, lines);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections && elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          if (wasDiscountOpen) {
            document.querySelectorAll('.cart-discounts--title').forEach((el) => {
              el.closest('details').setAttribute('open', '');
            });
          }
          if (root) CartFocus.restore(root, lines, focus, root.querySelector('.cart-discounts--input'));
          outcome = kept;
          if (refused) {
            setTimeout(() => {
              document.querySelectorAll('.cart-discounts--error').forEach((el) => {
                el.removeAttribute('hidden');
              });
            }, 300);
          }
        }, (error) => {
          // The request failed: the form stays as it was, with the reason.
          // (An error while redrawing after a success is only logged.)
          console.error(error);
          this.querySelectorAll('.cart-discounts--button').forEach((el) => {
            el.classList.remove('loading');
          });
          if (errorEl) {
            const reply = error.body || {};
            errorEl.querySelector('.cart-discounts--error-text').textContent = reply.description || theme.strings.cartError;
            errorEl.removeAttribute('hidden');
          }
        })
        .catch((error) => console.error(error));
    }
  }
  customElements.define('cart-discounts', CartDiscounts);
}